import { defaultOfflineCartRules } from './default-rules.js';
import { createValidationReads } from './read-cache.js';
import type { ValidateOfflineCartArgs, ValidationIssue, ValidationReport } from './types.js';

export async function validateOfflineCart(args: ValidateOfflineCartArgs): Promise<ValidationReport> {
  const reads = createValidationReads({ sources: args.sources });
  const rules = args.rules ?? defaultOfflineCartRules;
  const results = await Promise.all(rules.map(async (rule): Promise<readonly ValidationIssue[]> => {
    try {
      return rule.kind === 'pure' ?
        rule.run({ cart: args.cart, now: args.now }) :
        await rule.run({ cart: args.cart, now: args.now, reads });
    }
    catch(cause) {
      try {
        void Promise.resolve(args.onRuleFailure?.({ ruleId: rule.id, cause })).catch(() => {
          // Async diagnostics failures are best effort too.
        });
      }
      catch{
        // Diagnostics are best effort and must not hide validation issues.
      }
      return [{
        ruleId: rule.id,
        code: 'RULE_FAILED',
        path: '',
        message: 'Cart rule could not be completed',
      }];
    }
  }));
  const issues = results.flat();
  return { valid: issues.length === 0, issues };
}
